import { render, staticRenderFns } from "./CatGatherTotalRuleConfig.vue?vue&type=template&id=46cd9f5f&scoped=true"
import script from "./CatGatherTotalRuleConfig.vue?vue&type=script&lang=js"
export * from "./CatGatherTotalRuleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cd9f5f",
  null
  
)

export default component.exports